
var SparkMD5 = require('../vendor/spark-md5');
var Cookies;
if ( ! LOBBYLESS_ENV )
{
    Cookies = require( '../vendor/js.cookie' );
}
var versionInfo = require('src/version');

/** Каждые сколько секунд, по меньшей мере, от сервера должно быть получено текущее количество кредитов.*/
var CREDITS_POLL = 5;

export const cookiesSettings =
{
    path : "/",
    domain : undefined
};

export const cookies =
{
    get : function( name )
    {
        if ( LOBBYLESS_ENV )
        {
            switch ( name )
            {
                case "session_id":
                    return this.session_id;
                case "refresh_token":
                return this.refresh_token;
            }
        }
        else
        {
            var cookie = Cookies.get( name, cookiesSettings );
            if ( typeof cookie === 'string' )
            {
                var result = cookie.split( "|" );
                //console.log( "Cookie \"" + name + "\" obtained as \"" + result[ 0 ] + "\" under \"" + result[ 1 ] + "\"." );
                return result[ 0 ];
            }
            console.error( "Obtaining cookie \"" + name + "\" is NOT of type string, it's " + ( typeof cookie ) + ", value = " + cookie );
            return undefined;
        }
    },

    set : function( name, value, place )
    {
        if ( LOBBYLESS_ENV )
        {
            switch ( name )
            {
                case "session_id":
                    this.session_id = value;
                    return;

                case "refresh_token":
                    this.refresh_token = value;
                    return;
            }
        }
        else
        {
            //console.log( "Setting cookie \"" + name + "\" to \"" + value + "\" under \"" + place + "\"." );
            Cookies.set( name, value/* + "|" + place*/, cookiesSettings );
        }
    }
};

export const OPERATION_ID =
{
    SESSION_START_LOGIN : 100,
    SESSION_START_TERMINAL : 110,
    SESSION_START_CARD_AND_TERMINAL : 120,
    SESSION_REFRESH : 130,
    SESSION_CLOSE : 140,

    USER_SETTINGS_SET : 200,
    USER_SETTINGS_GET : 210,
    STATE_GET : 220,
    STATE_PREVIOUS_GET : 230,
    SCENARIO_GAME_BEGIN : 240,
    WAY_SELECT : 250,
    SCENARIO_RISK_BEGIN : 260,
    SCENARIO_SKIP_TO_RISK : 265,
    SPECIFICATION_GET : 270,
    WIN_TABLE_GET : 271,
    CLIENT_DATA_APP_SET : 280,
    CLIENT_DATA_APP_GET : 290,

    CLIENT_DATA_SCENARIO_SET : 300,
    CLIENT_DATA_SCENARIO_GET : 310,
    RISK_HISTORY_GET : 320,
    WATCH_RECORDS_GET : 330,
    STEP_CHECK : 340,

    BALANCE_GET : 400,
    PROGRESSIVE_JACKPOT_GET : 401,
    CODE_ACTIVATE : 410,
    CODE_GENERATE : 420,
    CODE_HISTORY : 430,
};
function operationName( operationId )
{
    for ( var name in OPERATION_ID )
    {
        if ( OPERATION_ID[ name ] == operationId )
        {
            return name;
        }
    }

    return "UNKNOWN OPERATION";
}

/**
    * Process server response invoking corresponding handlers for every requested operation.
    * @param response Server response decoded JSON data
    * @param {ReadyRequest} readyRequest
    * @return {Boolean} true if request needs to be resent
    */
function handleResponse(
    response,
    readyRequest
)
{
    readyRequest.server.lastCreditsUpdate = Date.now();

    readyRequest.server.creditsBeingUpdated = false;
    
    //no matter how messages was ordered:
    delete readyRequest.server.sessionRefreshPending

    if ( response.hasOwnProperty( "success" ) && response.success == false )
    {
        readyRequest.server.enterFatal( readyRequest.onFatal, response.error ? response.error.message : "unknown message" );
        return;
    }

    if ( ! response.service )
    {
        //в ответах на trace сервер не присылает даже "service" part, а в таких (trace) запросах ни onResult ни onError/onFatal никому не интересны:
        if ( readyRequest.onFatal instanceof Function )
        {
            readyRequest.server.enterFatal( readyRequest.onFatal, "no service part" );
        }
        return;
    }

    //checking the service part:
    if ( response.service.hasOwnProperty( "success" ) && response.service.success == false )
    {
        //ERROR_REQUEST_ALREADY_IN_QUEUE: сервер слишком сильно нагружен и не успел обработать подобный запрос в рамках timeout'а и на новый [пере]запрос ответил что он ещё обрабатывает предыдущий, поэтому нужно подождать и спросить заново:
        if ( response.service.error && response.service.error.code == 110 )
        {
            return true;
        }
        
        //ERROR_SESSION_NOT_FOUND может сопровождаться URL'ом для перенаправления:
        if ( response.service.error && response.service.error.code == 300 )
        {
            if ( response.service.error.details && response.service.error.details.redirect_url )
            {
                readyRequest.server.enterFatal(
                    readyRequest.onFatal,
                    response.service.error.message,
                    false,
                    response.service.error.details.redirect_url
                );
                return;
            }
        }

        readyRequest.server.enterFatal( readyRequest.onFatal, response.service.error.message );
        return;
    }

    //при обновлении сессии сервер в "service" возвращает остаток жизни сессии, которую и обновляли (а не той НА которую обновились), поэтому клиент (то есть "мы") может подумать что сессию опять нужно обновить, однако договорились что сервер в самом operation'е обновления сессии будет также возвращать остаток жизни УЖЕ НОВОЙ сессии, поэтому важно чтобы эта строчка была ПЕРЕД обработкой operation'ов:
    readyRequest.server.sessionTimeLeft = response.service.result.session_time_left;
    
    if ( ! response.main )
    {
        readyRequest.server.enterFatal( readyRequest.onFatal, "no \"main\" part" )
        return
    }

    if ( response.main && response.main.hasOwnProperty( "success" ) && response.main.success == false )
    {
        readyRequest.server.enterFatal( readyRequest.onFatal, response.main.error.message );
        return;
    }
    
    //reactive bindings:
    var type = undefined;
    var state = undefined;
    var balance = undefined;
    let jackpot_progressive = undefined

    //раздаём все части ответа всем получателям:
    response.main.result.operations.forEach( function( operation )
    {
        //if within some previous receiver error has been detected:
        if ( readyRequest.server.ok !== true )
        {
            return;
        }

        if ( operation.success !== true )
        {
            switch ( operation.error.code )
            {
                //ERROR_CREDITS_TOO_MUCH "Если кредитов больше лобби должна вывести сообщение пользователю что играть дальше нельзя пока кредитов не станет меньше чем gamable_limit":
                case 510:
                    readyRequest.server.enterFatal( readyRequest.onFatal, 'ERROR_CREDITS_TOO_MUCH' );
                    return;
                //"You need set session_id":
                case 300:
                    readyRequest.server.enterFatal( readyRequest.onFatal, operation.error );
                    return;
                default:
                    readyRequest.server.enterFail( readyRequest.onFail, "Operation " + operationName( operation.id ) + " failed on server: " + JSON.stringify( operation.error ) );
                    return;
            }
        }

        //ИМЕННО при логине session_time_left корректно указывается только в operation'е самого логина, а в service == null:
        if ( ! readyRequest.server.sessionTimeLeft )
        {
            if ( operation.id == OPERATION_ID.SESSION_START_LOGIN )
            {
                try
                {
                    readyRequest.server.sessionTimeLeft = operation.result.session_time_left;
                }
                catch ( e )
                {
                    console.error( "⚡⚡⚡ Session time left read fail: " + e );
                }
            }
        }

        switch ( operation.id )
        {
            case OPERATION_ID.STATE_GET:
                //in case of "totalizator" math server may respond with "wait a bit", so just ignore it:
                if ( ! operation.result.stage ) break
                
                readyRequest.server.step_id = operation.result.step_id;
                type = operation.result.stage.type_id;
                state = operation.result;
                readyRequest.server.stateOrder = readyRequest.server.stateOrder ? readyRequest.server.stateOrder + 1 : 1;
                break;
                
            case OPERATION_ID.BALANCE_GET:
                balance = operation.result;
                break;
            
            case OPERATION_ID.PROGRESSIVE_JACKPOT_GET:
                readyRequest.server.$progressive_jackpot.next( operation.result )
                break
        }

        //looking for specified Receiver:
        for ( var receiverIndex in readyRequest.requestData.receivers )
        {
            if ( readyRequest.requestData.receivers.hasOwnProperty( receiverIndex ) == false )
            {
                continue;
            }

            var receiver = readyRequest.requestData.receivers[ receiverIndex ];

            if ( receiver.operationId == operation.id )
            {
                receiver.callback( operation.result );
                delete readyRequest.requestData.receivers[ receiverIndex ];
            }
        }
    } );

    if ( readyRequest.server.ok !== true )
    {
        return;
    }

    if ( readyRequest.onSuccess !== undefined )
    {
        readyRequest.onSuccess();
    }
    
    if ( type !== undefined )
    {
        var lastNetState = {
            server : readyRequest.server,
            type : type,
            response : response,
            state : state
        };
        readyRequest.server.lastNetState = lastNetState;
        readyRequest.server.$net.next( {
            state : lastNetState,
            balance,
            jackpot_progressive
        } );
    }
}

const ATTEMPTS = 6
/** Effort to actually SEND (network-wise) the request and maybe try later if it failed within the specified amount of retries.
    * @param {ReadyRequest} readyRequest
    * @param {Number} tryCount How much attempts left to make before giving up and reporting onFail
    */
function issueRequest(
    readyRequest,
    tryCount
)
{
    tryCount = tryCount === undefined ? ATTEMPTS : tryCount;
    -- tryCount;
    
    readyRequest.server.updated = false

    const ajaxRequest =
    {
        type : 'POST',
        url : readyRequest.server.url,
        timeout : 3000
    }

    //попросили для trace запросов добавить параметр URL'а:
    if ( readyRequest.requestData.data.service.client_trace )
    {
        var sendLogs = 'trace="send logs"';
        if ( ajaxRequest.url.indexOf( '?' ) >= 0 )
        {
            sendLogs = '&' + sendLogs;
        }
        else
        {
            sendLogs = '?' + sendLogs;
        }
        ajaxRequest.url += sendLogs;
    }

    //preliminary JSONing to compute hash to sign:
    //подписывать на основе хэша нужно только один раз, иначе подпись "уплывёт":
    if ( ! readyRequest.signed )
    {
        var jsonRequest = JSON.stringify( readyRequest.requestData.data );
        //signing final request:
        readyRequest.requestData.data.service.security.sign = SparkMD5.hash( jsonRequest );

        readyRequest.signed = JSON.stringify( readyRequest.requestData.data );
    }

    ajaxRequest.data = readyRequest.signed;

    ajaxRequest.contentType = "application/json";
    ajaxRequest.dataType = "json";

    let actualRequest = readyRequest.server.net_service( ajaxRequest )
    
    function clean_up()
    {
        for ( const i in readyRequest ) delete readyRequest[ i ]
        for ( const i in ajaxRequest ) delete ajaxRequest[ i ]
    }

    actualRequest.done( function( data, textStatus, xhr )
    {
        const server = readyRequest.server
        
        //console.log( "⚡⚡⚡ Request #" + tryCount + " succeeded." );

        //вроде как всегда именно DONE, но пусть живёт атавизм:
        if ( xhr.readyState != XMLHttpRequest.DONE )
        {
            clean_up()
            return
        }
        
        -- server.requestsPending;
        
        if ( xhr.status != 200 )
        {
            server.enterFatal( readyRequest.onFatal, "Wrong status: " + xhr.status + ", status text: " + xhr.statusText );
            clean_up()
            return;
        }
        
        server.updated = true

        let resend = false;

        //TODO: это довольно опасный код и хочется чтобы вызов не просто провалился в небытие, а сообщил об ошибке в графическую часть, поэтому нужно вернуть try/catch, а сейчас нужно посмотреть причину многочисленных ошибок:
        /*try
            {*/
        resend = handleResponse(
            data,
            readyRequest
        );
        /*}
            catch( e )
            {
            onFail( e.message );
            }*/

        if ( resend === true )
        {
            if ( tryCount > 0 )
            {
                ++ server.requestsPending;
                setTimeout(
                    function ()
                    {
                        issueRequest(
                            readyRequest,
                            tryCount
                        );
                    },
                    1000
                );
            }
            else
            {
                server.enterFail( readyRequest.onFail, 'All resend attempts failed after', ATTEMPTS, 'tries' );
                clean_up()
            }
        }
        else
        {
            clean_up()
        }
        
        continueCommunication( server )
    } );
    actualRequest.fail( function( xhr, textStatus, errorThrown )
    {
        const server = readyRequest.server
        
        //для " 'NO CONNECTION' не раньше чем через 7 секунд" (есть предположения что при отсутствии доступа к сети Ajax возвращает ошибку мгновенно, а не через timeout):
        const delay = 7000 / ( ATTEMPTS - 1 );
        
        if ( readyRequest.mayBecomeOutdated && server.updated )
        {
            console.log( "⚡⚡⚡ Polling failed but state already updated, so ignoring." )
            clean_up()
            return
        }

        //прежде такая ошибка возникала крайне редко и только при тестировании на планшете с Wi-Fi, но, как, вроде бы, стало понятно, такая ошибка возникает при отключении сети:
        if ( errorThrown === '' )
        {
            console.error( "⚡⚡⚡ Ajax' anonymous error. Probably network failure." );
            //не всегда проблемы с сетью отображаются как ошибка с пустой строкой - попытки плюс задержки всё-равно выравнены на " 'NO CONNECTION' не раньше чем через 7 секунд":
            /*//пусть при проблемах с сетью будет у устройства больше шансов восстановить подключение:
            delay = 5000;*/
        }

        //слишком долго не получаем ответ:
        if (
            //пусть пока повторные попытки совершаются при ЛЮБОЙ технической неудаче:
            /*( textStatus == 'timeout'
            //иногда на планшетах случается феерическая ошибка неизвестной природы, где ajax возвращает пустую строку в виде текста ошибки. Надеемся что подход совершения повторных попытком подключения решит и эту проблему в том числе:
            || errorThrown == '' )
            && */tryCount > 0
        )
        {
            console.log( "⚡⚡⚡ Request failed: " + errorThrown + ", " + textStatus + ". Issuing retry #" + tryCount + ' in ' + delay + ' ms ...' );

            setTimeout(
                function()
                {
                    /*//только для логов в рамках текущей отладки/тестирования:
                    if ( ! readyRequest.server.retries )
                    {
                        readyRequest.server.retries = [];
                    }
                    readyRequest.server.retries.push( errorThrown );*/

                    issueRequest(
                        readyRequest,
                        tryCount
                    );
                },
                delay
            );
        }
        else
        {
            -- server.requestsPending;
            
            console.log( '⚡⚡⚡ No retries remaining to recover server communication.' );
            server.enterFail(
                readyRequest.onFail,
                "Server: request failed: status: " + textStatus + ", error: " + errorThrown + ". Request string: " + jsonRequest + ". responseText: " + xhr.responseText
            );
            
            clean_up()
        }
        
        continueCommunication( server )
    } );

    /*var retriesCount = 0;
    var retriesString = '';
    if ( readyRequest.server.retries )
    {
        retriesCount = readyRequest.server.retries.length;
        retriesString += '| ';
        for ( var retryIndex in readyRequest.server.retries )
        {
            if ( readyRequest.server.retries.hasOwnProperty( retryIndex ) )
            {
                retriesString += readyRequest.server.retries[ retryIndex ] + ' | ';
            }
        }
    }
    console.log( "⚡⚡⚡ Request #" + tryCount + " sent. Gross " + retriesCount + " retries: " + retriesString );*/
}

function continueCommunication( server )
{
    //in case session refreshing message on it's own failed to commute:
    if ( ! server.ok ) return
    
    //if any communication still happening (for example polling with session refreshing) then need to wait:
    if ( server.requestsPending > 1 ) return
    
    //no actually queues - only one postponement is allowed and supported:
    if ( ! server.postponedRequest ) return
    
    //since postponed request was already counted and we emulate it's original issuing now, we have to pretend that it didn't happen yet:
    -- server.requestsPending
    
    const p = server.postponedRequest
    delete server.postponedRequest
    p()
}

//was told that it's obligatory to add leading zeroes (but it works without):
function pad( num )
{
    let s = num + "";
    while ( s.length < 2 ) s = "0" + s;
    return s;
}

function GeneralRequest( server )
{
    var date = new Date;
    var utcDate =
        date.getFullYear() + "-" +
        pad( date.getMonth() + 1 ) + "-" +
        pad( date.getDay() ) + " " +
        pad( date.getHours() ) + ":" +
        pad( date.getMinutes() ) + ":" +
        pad( date.getSeconds() );

    return {
        data :
        {
            main : {
                operations : []
            },
            service : {
                header : {
                    protocol_version : "2.2",
                    session_id : cookies.get( "session_id" ) || "",
                    //server.credential будет undefined если логин осуществляется прямо из игры (без лобби):
                    credential: server.credential || {},
                    params : server.urlParameters,
                    app : {
                        id : server.gameId,
                        version : versionInfo.build,
                        name : server.name || "not specified"
                    }
                },

                security : {
                    //теперь должно быть int32:
                    rand : Math.floor( Math.random() * 2147483648 ),
                    time : utcDate,
                    timestamp : Math.floor( date.getTime() / 1000.0 ),
                    //говорят что нужно именно сквозное время, а не просто микросекунды с произвольного момента (в данном случае - со старта страницы браузера):
                    //microtime : ( window.performance.now() * 1000.0 ),
                    //сказали что должен быть остаток от секунд:
                    microtime : ( date.getTime() % 1000 ) * 1000.0,
                    sign : "#490r876+YZ9xP",
                    client_id : 1,
                    disable_anti_spamming : ( server.disable_anti_spamming === undefined ? undefined : server.disable_anti_spamming ),
                },

                operations : []
            }
        },
        receivers : []
    };
}

/**
    * Make and send request. Single request may have many operations.
    * @param server
    * @param operationId Constant from OPERATION_ID. May be an Array if needs to send many operations within single request; onResult and params must be Arrays then.
    * @param onResult function( responseData : Object | NULL ) Null if request failed ( success == false or something else bad happened). Array of functions if operationId is Array.
    * @param params Optional operation parameters. Object. May be undefined. Keep order within Array with undefined values if need to specify some in case operationId is Array.
    * @param onSuccess Called at the very end of all operation callbacks calls.
    * @param onFail function( error : String ) If anything goes wrong at any stage, this is called. No onResult will be called after it.
    * @param trace Текстовое сообщение для отправки на сервер в качестве логирования происходящего на клиенте.
    * @param onFatal function( error : String ) Когда случается какая-то ошибка, после которой и не нужно пытаться восстановиться, а предложить игроку перейти в лобби.
    */
export function request(
    server,
    operationId,
    onResult,
    params,
    onSuccess,
    onFail,
    onFatal,
    trace,
    mayBecomeOutdated
)
{
    //если с сервером итак уже идёт общение по вопросам логики игры, то вызов других запросов в это время (обычно в этом же стеке) скорее-всего является ошибкой (результатом жмаканья клавиш с повешанными callback'ами на запрос к серверу, восстановление состояния с примесью предыдущего состояния и т.д.), поэтому попытаемся её решить просто игнорированием таких запросов - быть более стойкими к такого рода misuse'ам:
    if (
        //один запрос на поллинг и один на логику:
        server.requestsPending > 1 ||
        //только один запрос на логику если никакого поллинга нету:
        ( server.requestsPending > 0 && ! server.polling )
    )
    {
        console.trace( '⚡⚡⚡ Dropping request because some already pending.' );
        setTimeout( () => server.enterFail( onFail, "Automatic recovering attempt after request drop" ), 1 )
        return;
    }
    //есть предположение что не дожидаясь успешного восстановления связи игра также делает вторичные запросы, а после возвращения связи - оба запроса проходят на сервер, что приводит к ошибке:
    if ( server.ok !== true )
    {
        console.trace( '⚡⚡⚡ Dropping request because server is NOT OK.' );
        return;
    }
    
    //в рамках определения инактивности сетевого общения для поллинга баланса (да и вообще любой другой логики которая потенциально может появиться в будущем) эта асинхронная операция отложенного запроса для предоставления возможности сервера успеть выполнить операцию выглядит как "pending request":
    ++ server.requestsPending;
    
    if ( server.sessionRefreshPending )
    {
        server.postponedRequest = () => request.apply( null, arguments )
        return
    }
    
    var requestData = new GeneralRequest( server );
    if ( operationId == OPERATION_ID.SESSION_START_LOGIN )
    {
        let id = 101
        
        if ( server.totalizator ) id = 112
        else if ( server.tableMode ) 111
        
        requestData.data.service.header.app.id = id
    }

    if ( trace !== undefined )
    {
        requestData.data.service.client_trace = trace;
    }

    if ( operationId instanceof Array )
    {
        //нужно сохранять гарантию того что команды будут отправлены на сервер в том же порядке что и назначены, поэтому итерируемся здесь через индекс, а не через "for each/in..." (второй способ не гарантирует сохранение порядка итерации):
        for ( var i = 0; i < operationId.length; ++ i )
        {
            addOperation(
                operationId[ i ],
                onResult === undefined ? undefined : onResult[ i ],
                params === undefined ? undefined : params[ i ],
                requestData,
                server
            );
        }
    }
    else if ( operationId !== undefined )
    {
        addOperation( operationId, onResult, params, requestData, server );
    }
    
    sessionKeep( server, requestData )

    issueRequest(
        {
            server,
            requestData,
            onSuccess,
            onFail,
            onFatal,
            mayBecomeOutdated,
        }
    )
}

//append another operation into the request:
/** Создать образец операции, пригодной для всех запросов и добавить её в указанный запрос.
    В одном запросе может быть сразу несколько операций.*/
function addOperation( operationId, callback, addingParams, requestData, server )
{
    const operation = {
        id : operationId,
        name : operationName( operationId ),
        params : {}
    };

    if ( addingParams !== undefined )
    {
        operation.params = addingParams;
    }
    //добавляем порядковый номер stage'а для реализации логики на сервере по верификации следования клиента по цепочке stage'ей внутри сценария чтобы два клиента под одним аккаунтом в одной игре не перезатирали клиентские данные друг друга:
    switch ( operationId )
    {
        case OPERATION_ID.SCENARIO_GAME_BEGIN:
        case OPERATION_ID.SCENARIO_RISK_BEGIN:
        case OPERATION_ID.WAY_SELECT:
            operation.params.step_id = server.step_id;
            break;
    }

    requestData.data.main.operations.push( operation );

    //receiver-less requests are okey when you send batch requests which is logically a single one:
    if ( callback !== undefined && callback !== null )
    {
        requestData.receivers.push( {
            operationId,
            callback
        } )
    }
}

function sessionKeep( server, requestData )
{
    //добавляем к запросу обновление сессии, если она вот-вот устареет:
    if ( server.sessionTimeLeft <= 0 )
    {
        //console.log( '⚡⚡⚡ Appending session refreshing operation ...' );
        
        addOperation(
            OPERATION_ID.SESSION_REFRESH,
            sessionRefresh =>
            {
                //с Евгением обсуждали что возможно в будущем эта команда будет возвращать новый refresh_token (а сейчас он пока старый остаётся) - зависит от приоритетов безопасности:
                //cookies.set( "refresh_token", sessionRefresh.refresh_token, "session refresh" );

                cookies.set( "session_id", sessionRefresh.session_id, "session refresh" );

                //нет смысла беспокоиться о других потенциальных читателях печенек, так как они всё-равно могут прочитать их между этой попыткой записи оных и их фактической записью, что приведёт к наличию двух разных идентификаторов сессий (если они решал что её пора обновить в этот момент), поэтому разрыв соединения в таком случае всё-равно неизбежен:
                /*//flush:
                while ( cookies.get( "session_id" ) !== sessionRefresh.session_id )
                {
                }*/

                server.sessionTimeLeft = sessionRefresh.session_time_left;
                
                //console.log( '⚡⚡⚡ Session successfully refreshed for ' + server.sessionTimeLeft + ' more time.' );
            },
            {
                refresh_token : cookies.get( "refresh_token" ),
                session_id : cookies.get( "session_id" ) || ""
            },
            requestData,
            server
        );
        
        server.sessionRefreshPending = true
    }
    else
    {
        //console.log( '⚡⚡⚡ No need to refresh session: ' + server.sessionTimeLeft + ' more time remaining ...' );
    }
}

function initCreditsPoll( server )
{
    /*//поллинг часто мешает отлаживать своими регулярными сообщениями, засоряя консоль: тут раскомментить можно блок чтобы его отключить на время дебага:
    if ( NODE_ENV === 'development' )
    {
        console.log( "CAUTION: polling is turned OFF now in development mode!" );
        return;
    }*/

    //отправляем запрос обновления кредитов если игрок сам их не инициирует:
    setInterval(
        () => poll( server ),
        // делить на 2 потому что из-за подсчёта времени с помощью Date.now() образовываются промежуточные состояния при которых баланс не запрашивается (так как 5 секунд ещё не прошло (не хватает несколько миллисекунд)):
        CREDITS_POLL * 1000 / 2
    );
}

export function init( server )
{
    /** Случилось ошибка в общении с сервером, после которой нужно заново вызвать handleLobby() для восстановления состояния (просто повторного подключения к лобби).*/
    server.enterFail = function( onFail, message )
    {
        this.$error.next( { type : "fail", message } );

        //бывают запросы на которые безразличен ответ, значит ничего не делаем:
        if ( ! ( onFail instanceof Function ) )
        {
            console.error( "Enter fail: not a function :(" );
            return;
        }

        this.ok = false;
        this.failed = Date.now();
        onFail( message );
    };
    /** Случилась фатальная ошибка в общении сервером, после которой не нужно и пытаться восстановиться состояние, а просто показать игроку ошибку (или просто окошко о какой-то ошибке) и предложить вернуться в лобби.*/
    server.enterFatal = function( onFatal, message, instant, redirectUrl )
    {
        this.$error.next( {
            type : "fatal",
            message,
            redirectUrl
        } );

        //бывают запросы на которые безразличен ответ, значит ничего не делаем:
        if ( ! ( onFatal instanceof Function ) )
        {
            return;
        }

        this.ok = false;
        onFatal( message, instant, redirectUrl );
    };

    //в режиме мониторинга поллинг кредитов не имеет смысла (а сессия обновляется в рамках получения данных для мониторинга):
    if ( ! server.monitor )
    {
        initCreditsPoll( server );
    }
}

export function poll( server )
{
    //если общение с сервером встретило какую-то ошибку и ожидает восстановления:
    if ( server.failed !== undefined )
    {
        return;
    }

    //если сейчас общение с сервером перешло в ошибочное состояние и либо осуществляется реконнект либо фатал - поллинг бессмысленно:
    if ( server.ok !== true )
    {
        return;
    }

    if ( server.requestsPending > 0 )
    {
        return
    }
    
    if ( ( Date.now() - server.lastCreditsUpdate ) < ( CREDITS_POLL * 1000 ) )
    {
        return
    }
    
    server.polling = true;
    
    request(
        server,
        [
            OPERATION_ID.BALANCE_GET,
            OPERATION_ID.PROGRESSIVE_JACKPOT_GET,
            OPERATION_ID.STEP_CHECK,
        ],
        [
            function( balance )
            {
                server.balance = balance;

                if ( server.onCreditsPoll instanceof Function )
                {
                    server.onCreditsPoll( parseInt( balance.gameable ) );
                }
                
                server.$balancePoll.next( balance );
            },
        ],
        [
            undefined,
            undefined,
            {
                step_id : server.step_id
            },
        ],
        function()
        {
            server.polling = false;
        },
        function( errorString )
        {
            server.polling = false;
            
            if ( server.onFail instanceof Function )
            {
                server.onFail( "Error: request.init(): timer-wise balance polling failed: " + errorString );
            }
        },
        function( errorString )
        {
            server.polling = false;
            
            if ( server.onFatal instanceof Function )
            {
                server.onFatal( "Error: request.init(): time-wise balance polling failed: " + errorString );
            }
        },
        undefined,
        true
    )
}





// WEBPACK FOOTER //
// ./src/library/network/request.es6